import React from 'react';

export const XIcon = (): JSX.Element => (
  <svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 20 20' fill='none'>
    <path
      d='M14.714 2.92849C15.3649 2.27762 16.4202 2.27762 17.0711 2.92849C17.7219 3.57937 17.7219 4.63464 17.0711 5.28552L5.28596 17.0706C4.63508 17.7215 3.57981 17.7215 2.92894 17.0706C2.27806 16.4198 2.27806 15.3645 2.92894 14.7136L14.714 2.92849Z'
      fill='#5E6D79'
    />
    <path
      d='M17.0711 14.7136C17.7219 15.3645 17.7219 16.4198 17.0711 17.0706C16.4202 17.7215 15.3649 17.7215 14.7140 17.0706L2.92893 5.28551C2.27806 4.63464 2.27806 3.57937 2.92893 2.92849C3.57980 2.27762 4.63508 2.27762 5.28595 2.92849L17.0711 14.7136Z'
      fill='#5E6D79'
    />
  </svg>
);
